
import { Component, Vue } from "vue-property-decorator";
import { emptyToLine } from "@common/src/utils/common";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { formDownload } from "@common/src/utils/tools";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import DataImport from "@common/src/components/scope/data-import/index.vue";
const base = namespace("base");
const marketing = namespace("marketing");

@Component({
  components: {
    DataImport
  }
})
@Table.DataImport({
  templateCode: "importGiftCard",
  actionUrl: "/filecloud/importGiftCard"
})
@Table("loadListData")
export default class CardGift extends Vue {
  @base.Action getDictionaryList;
  @marketing.Action queryGiftCardList;
  emptyToLine = emptyToLine;
  dayjs = dayjs;
  searchForm = {
    issuerTimeBegin: "",
    issuerTimeEnd: "",
    redeemTimeBegin: "",
    redeemTimeEnd: "",
    status: "",
    cardNo: "",
    customerName: "",
    customerMobile: "",
    giftCardNumber: ""
  };
  cardStatusList = [];
  dataList = [];
  get searchList() {
    return [
      {
        label: t("v3_4_9.create-time"),
        type: "daterange",
        value: "",
        prop: "issuerTime"
      },
      {
        label: t("v3_4_9.activation-time"),
        type: "daterange",
        value: "",
        prop: "redeemTime"
      },
      {
        label: t("v3_4_9.card-status"),
        type: "select",
        value: "",
        selectList: this.cardStatusList,
        prop: "status"
      },
      {
        label: t("v3_4_9.card-number"),
        type: "input",
        value: "",
        prop: "giftCardNumber"
      },
      {
        label: t("v3_4_9.customer-name"),
        type: "input",
        value: "",
        prop: "customerName"
      },
      {
        label: t("v3_4_9.customer-phone"),
        type: "input",
        value: "",
        prop: "customerMobile"
      },
      {
        label: t("v3_4_9.linked-system-card-number"),
        type: "input",
        value: "",
        prop: "cardNo"
      }
    ];
  }
  created() {
    this.init();
    this.loadListData();
  }
  init() {
    this.getDictionaryList("gift_card_status").then(data => {
      this.cardStatusList = data;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryGiftCardList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.dataList = data.data.list;
      return data;
    });
  }
  handleImportSuccess() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "issuerTime") {
          this.searchForm["issuerTimeBegin"] = item.value ? item.value[0] : "";
          this.searchForm["issuerTimeEnd"] = item.value ? item.value[1] : "";
        } else if (item.prop === "redeemTime") {
          this.searchForm["redeemTimeBegin"] = item.value ? item.value[0] : "";
          this.searchForm["redeemTimeEnd"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  downLoadQrCode() {
    const urlMap = {
      test: "https://static.gtech.asia/static/speedbiz/temp/temp_17367365906607.png",
      other: "https://static.gtech.asia/static/speedbiz/temp/temp_17339672919150.png"
    };
    const env = window.location.host.includes("test") ? "test" : "other";
    fetch(urlMap[env])
      .then(response => response.blob())
      .then(blob => {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "QR" + new Date().getTime() + ".png";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch(error => {
        console.log(error, "下载失败");
      });
  }
  handleExportData() {
    formDownload(`${window.API_URL}/gift/card/download`, this.searchForm);
  }
}
